import ScrollColumn2D from './scrollcolumn2d';
import AreaDataset from '../_internal/datasets/area';
import { HUNDREDSTRING, preDefStr } from '../_internal/lib/lib';
let UNDEF,
  SEVENTYSTRING = preDefStr.SEVENTYSTRING;
/**
 * Creates ScrollArea2D class
 */
class ScrollArea2D extends ScrollColumn2D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'ScrollArea2D';
  }

  /**
   * Constructor fn of ScrollArea2D class
   */
  constructor () {
    super();
    this.canvasborderthickness = 1;
    this.hasScroll = true;
    this.avgScrollPointWidth = 75;
    this.defaultPlotShadow = 0;
    this.binSize = 0;
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'ScrollArea2D';
  }
  /**
   * Sets default chart configuration
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = 'Scrollable Multi-series Area Chart';
    config.defaultDatasetType = 'scrollarea2d';
    config.enablemousetracking = true;
    config.anchorborderthickness = 1;
    config.anchorimageurl = UNDEF;
    config.anchorimagepadding = 1;
    config.anchorsides = 1;
    config.anchoralpha = UNDEF;
    config.anchorbgalpha = HUNDREDSTRING;
    config.anchorimagealpha = HUNDREDSTRING;
    config.anchorimagescale = 100;
    config.anchorstartangle = 90;
    config.anchorshadow = 0;
    config.anchorbgcolor = UNDEF;
    config.anchorbordercolor = UNDEF;
    config.anchorradius = 3;
    config.showvalues = 1;
    config.plotfillalpha = SEVENTYSTRING;
    config.linedashlen = 5;
    config.linedashgap = 4;
    config.linedashed = UNDEF;
    config.linealpha = HUNDREDSTRING;
    config.linethickness = 2;
    config.drawfullareaborder = 1;
    config.connectnulldata = 0;
    config.defaultcrosslinethickness = 1;
  }

  /** This method return the dataset definations for this charts **/
  getDSdef () {
    return AreaDataset;
  }
  /** This method return the dataset-group definations for this charts **/
  getDSGroupdef () {
    return undefined;
  }
}
export default ScrollArea2D;
